export default __webpack_public_path__ + "static/media/bookstore.aa2628cc.png";